import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { BLOCKS } from '@contentful/rich-text-types';
import moment from 'moment';
import get from 'lodash/get';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { setTheme } from 'utils/themeHelper';
import { selectPrimoTransitionBanner } from 'containers/Landing/selectors';
import { selectBranch } from 'containers/UserRegion/selectors';
import PrimoLearnMoreDialog from 'components/Dialogs/PrimoLearnMoreDialog/Loadable';
import { getContentOptions } from '../CollapseBanner/parserOptions';
import Button from '../Button';
import styles from './water-regional.scss';

const PrimoTransitionBanner = ({
  document,
  isAuthenticated,
  userRegionBranch,
  serviceLocation,
  primoTransitionBanner,
}) => {
  const [openPrimoLearnMoreDialog, setOpenPrimoLearnMoreDialog] = useState(
    false,
  );

  if (
    isAuthenticated &&
    (!serviceLocation || !(serviceLocation.bannerCode === 'COSTCO PRIMO'))
  ) {
    return null;
  }

  const options = {
    renderNode: {
      ...Object.assign(getContentOptions(styles, theDocument).renderNode, {
        [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
          const id = get(node, 'data.target.sys.contentType.sys.id');

          switch (id) {
            case 'button':
              return (
                <Button
                  className={styles.btn}
                  document={node.data.target}
                  onClick={() => {
                    setOpenPrimoLearnMoreDialog(true);
                  }}
                >
                  {children}
                </Button>
              );
            default:
              return null;
          }
        },
        [BLOCKS.EMBEDDED_ASSET]: (node) => {
          if (!get(node, 'data.target.fields.title', false)) {
            return null;
          }

          const {
            fields: { file, description },
          } = node.data.target;

          return (
            <div className={styles.embeddedAsset}>
              <img src={`${file.url}?fm=webp`} alt={description} />
            </div>
          );
        },
        [BLOCKS.PARAGRAPH]: (node, children) => {
          const contentfulText = Array.isArray(children)
            ? children[0]
            : children;
          const dates = branchDates[theBranch] || 'Coming Soon';
          const bannerText = contentfulText.replace(
            '$Date',
            dates.transitionDate,
          );
          return <div className={styles.text}>{bannerText}</div>;
        },
      }),
    },
  };

  const theDocument = document?.fields
    ? document
    : { ...primoTransitionBanner };

  const theBranch = isAuthenticated
    ? serviceLocation.branchCode
    : userRegionBranch;

  const branchDates = get(
    theDocument,
    'fields.features.content[0].content[0].value',
    '',
  )
    .split('\n')
    .map((item) => item.trim())
    .filter((item) => item.length > 0)
    .reduce((acc, item) => {
      const branchDate = item.replace(/\s\s+/g, ' ').split(' ');
      const [branch, showDate, transitionDate] = branchDate;
      acc[branch] = { showDate, transitionDate };
      return acc;
    }, {});

  const learnMore = get(
    theDocument,
    'fields.bottomContent.content[0].data.target.fields',
    '',
  );

  const content = documentToReactComponents(
    theDocument && theDocument.fields && theDocument.fields.content,
    options,
  );

  if (!branchDates[theBranch]) {
    return null;
  }
  const { transitionDate, showDate } = branchDates[theBranch];
  const isSameOrAfterShowDate = moment().isSameOrAfter(
    moment(showDate, 'MM/DD/YYYY'),
  );
  const isBeforeTransitionDate = moment().isBefore(
    moment(transitionDate, 'MM/DD/YYYY'),
  );

  const showBanner = isSameOrAfterShowDate && isBeforeTransitionDate;

  return (
    showBanner && (
      <div className={setTheme([styles.promotionBanner], theDocument, styles)}>
        <div className={styles.content}>
          <div className={styles.controlledContent}>
            <div className={styles.descriptionWrapper}>{content}</div>
          </div>
        </div>
        {openPrimoLearnMoreDialog && (
          <PrimoLearnMoreDialog
            open
            learnMore={learnMore}
            onClose={() => {
              setOpenPrimoLearnMoreDialog(false);
            }}
          />
        )}
      </div>
    )
  );
};

PrimoTransitionBanner.propTypes = {
  document: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  userRegionBranch: PropTypes.string,
  serviceLocation: PropTypes.object,
  primoTransitionBanner: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  userRegionBranch: selectBranch(),
  primoTransitionBanner: selectPrimoTransitionBanner(),
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrimoTransitionBanner);
